import { createPaginatedSlice, LOADING_KEY } from "../../../helpers/reduxHelper";

const paginatedProduct = createPaginatedSlice('paginatedProduct');

export const paginatedProductActions = paginatedProduct.actions
export const paginatedProductSelector = state => state.paginatedProduct;
export const paginatedProductReducer = paginatedProduct.reducer;
export default paginatedProductReducer

export const paginatedProductSelectors = paginatedProduct.LF.selectors